import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Extra.css";
import extraImg from "./assets/blue.jpeg"; // move your image inside src/assets

const Extra = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const highlights = [
    "Designed UI for Radha Enterprises (2024)",
    "Resolved bugs & added features in React projects (2024)",
    "Published Research Paper on Quicklearn in IJSRET (2024)",
    "Selected for college hackathon SIH (2022)",
    "O Level Certified (2022)",
    "Found bugs in college website (2022)",
    "Reported website bugs on Social Media (2022)",
    "Certification in Responsive Web Design, Adobe XD (2021)",
    "RTU Poornima Hackathon finalist (2021)",
    "Won College Drawing Competition (2021)",
  ];

  return (
    <div className="extra-wrapper">
      <Container>
        <Row className="align-items-center">
          {/* Left Image */}
          <Col md={6} data-aos="fade-right">
            <div className="extra-image">
              <img src={extraImg} alt="Extra Work" />
            </div>
          </Col>

          {/* Right Highlights */}
          <Col md={6} data-aos="fade-left">
            <h2 className="extra-heading">
              Some <span className="text-highlight">Extra Work</span>
            </h2>
            <div className="extra-cards">
              {highlights.map((item, index) => (
                <div key={index} className="extra-card" data-aos="fade-up">
                  {item}
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Extra;
